module.exports = __webpack_public_path__ + "static/media/lungs.31f9a5c3.svg";